export default __webpack_public_path__ + "img/bVCHitPx.d7a704fa.svg";